import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@core';
import { CreateDrillBody } from './dto/create-drill.body';
import { CreateDrillResponse } from './dto/create-drill.response';
import { GetDrillByIdResponse } from './dto/get-drill-by-id.response';
import { GetDrillsListResponse } from './dto/get-drills-list.response';
import { UpdateDrillBody } from './dto/update-drill.body';
import { UpdateDrillResponse } from './dto/update-drill.response';

@Injectable()
export class DrillsService extends ApiService {
  getList(): Observable<GetDrillsListResponse> {
    return this.httpClient.get<GetDrillsListResponse>(`${this.env.apiUrl}/drills`);
  }

  getOne(drillId: string): Observable<GetDrillByIdResponse> {
    return this.httpClient.get<GetDrillByIdResponse>(`${this.env.apiUrl}/drills/${drillId}`);
  }

  create(body: CreateDrillBody): Observable<CreateDrillResponse> {
    return this.httpClient.post<CreateDrillResponse>(`${this.env.apiUrl}/drills`, body);
  }

  update(drillId: string, body: UpdateDrillBody): Observable<UpdateDrillResponse> {
    return this.httpClient.patch<UpdateDrillResponse>(`${this.env.apiUrl}/drills/${drillId}`, body);
  }

  remove(drillId: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.env.apiUrl}/drills/${drillId}`);
  }

  toggleFavorite(drillId: string): Observable<UpdateDrillResponse> {
    return this.httpClient.patch<UpdateDrillResponse>(`${this.env.apiUrl}/drills/${drillId}/favorite`, {});
  }
}
